import React, { useState } from 'react'
import { Tabs } from 'antd'
import { DOCUMENT_TYPE } from '../../../constants'
import IncomingPanel from './IncomingPanel'
import OutgoingPanel from './OutgoingPanel'

const InternalDocumentDeletedConfig = () => {
  const [activeTab, setActiveTab] = useState(DOCUMENT_TYPE.INCOMING)

  return (
    <>
      <Tabs type="card" activeKey={activeTab} onChange={setActiveTab}>
        <Tabs.TabPane tab="Văn bản đến" key={DOCUMENT_TYPE.INCOMING} />
        <Tabs.TabPane tab="Văn bản đi" key={DOCUMENT_TYPE.OUTGOING} />
      </Tabs>

      {activeTab === DOCUMENT_TYPE.INCOMING && <IncomingPanel />}
      {activeTab === DOCUMENT_TYPE.OUTGOING && <OutgoingPanel />}
    </>
  )
}

export default InternalDocumentDeletedConfig
